<template>
  <div class="login">
    <MyTransition :myName="'up'">
      <Popup v-if="popupStatus">
        <PopupSuccess v-if="popup == 'success'" :text="successText" @check="poupupEnter"></PopupSuccess>
        <PopupError v-if="popup == 'error'" :text="successText" @check="poupupEnter"></PopupError>
      </Popup>
    </MyTransition>
    <div class="login_input flex" v-for="(input, index) in inputList" :key="index">
      <i :class="input.icon"></i>
      <input :type="input.type" v-model.trim="input.val" :placeholder="input.placeholder" @keyup.enter="login" />
    </div>
    <div class="login_btn">
      <button type="button" class="btn_border" @click="login">登入</button>
      <!-- <button type="button" class="btn_light" @click="registered" v-if="type==0">註冊</button> -->
    </div>
  </div>
</template>

<style lang="scss">
.login {
  // background: #fff;
}

.login_input {
  margin: 10px auto;
  // background: rgba($color: #fff, $alpha: 0.7);
  background: #d6c6ff;
  border-radius: 50px;
  align-items: center;
  padding: 1px 15px;
  max-width: 350px;

  i {
    color: #a280f9;
  }

  input {
    color: var(--mainColor);
    background: transparent;
    border: none;
    width: 100%;
    padding: 10px 5px;

    /*webkit瀏覽器專用*/
    &::-webkit-input-placeholder {
      color: #a280f9;
    }

    /*Firefox 4-18瀏覽器專用*/
    &::-moz-placeholder {
      color: #a280f9;
    }

    /*IE10瀏覽器專用*/
    &:-ms-input-placeholder {
      color: #a280f9;
    }
  }

  &:focus-within {
    background: #fff;
    // background: transparent;
    // border: 1px solid #fff;
    // input{
    //   color: #fff;
    // }
  }
}

.login_btn {
  margin: 20px 20px;

  >button {
    margin: 10px 0;
  }

  .btn_light {
    box-shadow: 10px 10px 20px -5px rgba($color: #270a70, $alpha: 0.8);

    &:hover {
      box-shadow: 3px 3px 5px -1px rgba($color: #270a70, $alpha: 0.8);
    }
  }
}
</style>

<script>
export default {
  name: "loginConten",
  props: {
    type: ""
  },
  data() {
    return {
      inputList: [
        { placeholder: "帳號", icon: "el-icon-user", val: null, type: "text" },
        {
          placeholder: "密碼",
          icon: "el-icon-lock",
          val: null,
          type: "password"
        }
      ],
      popupStatus: false,
      successText: null,
      popup: null
    };
  },
  methods: {
    registered() {
      this.$router.push("registered");
    },
    login() {
      //先判斷帳號密碼是否填寫
      if (!this.inputList[0].val && !this.inputList[1].val) {
        //有遺漏
        this.popupStatus = true;
        this.popup = "error";
        this.successText = `請輸入帳號密碼`;
      } else {
        //判斷登入身份
        if (this.type === 0) {
          //承攬商
          this.$http.api.login.vendorLogin({
            account: this.inputList[0].val,
            password: this.inputList[1].val
          })
            .then(res => {
              if (res.status == "200") {
                this.$store.commit("setUserData", res.data);
                //判斷承攬商目前的通過情況
                if (res.data.vendor.is_pass === 2) {
                  //已經認證通過
                  this.$router.push("/contractor");
                } else {
                  //還未
                  this.$router.push("/contractor/registered");
                }
              } else if (res.status == "201") {
                this.popupStatus = true;
                this.popup = "error";
                this.successText = `帳號密碼錯誤`;
                this.inputList[1].val = null;
              }
            })
            .catch(error => {
              this.popupStatus = true;
              this.popup = "error";
              this.successText = `登入失敗：${error}`;
            });
        } else if (this.type === 1) {
          //公安環安//需求單位
          this.$http.api.login.managerLogin({
            account: this.inputList[0].val,
            password: this.inputList[1].val
          })
            .then(res => {
              if (res.status == "200") {
                this.$store.commit("setUserData", res.data);
                //判斷是否為環安或需求單位
                if (res.data.manager.role.includes("manager")) {
                  //環安
                  this.$router.push("/admin");
                } else {
                  //需求單位
                  this.$router.push("/department");
                }

              } else if (res.status == "201") {
                this.popupStatus = true;
                this.popup = "error";
                this.successText = `帳號密碼錯誤`;
                this.inputList[1].val = null;
              }
            })
            .catch(error => {
              this.popupStatus = true;
              this.popup = "error";
              this.successText = `登入失敗：${error}`;
            });

        }
      }
    },
    poupupEnter() {
      this.popupStatus = false;
    }
  }
};
</script>